module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Introduction")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("We all like small fluffy creatures. I remember when my children were young, we used to enjoy going to the farmyard on open days to have cuddles with baby animals. Having never kept pets at home, my boys felt nervous, even a little scared of holding animals. However, they didn't seem to mind the chicks. I remember them cupping their hands to hold a little bird and gently stroking its feathers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although it is not made from natural fibres, I've always had a weak spot for fleecy yarn. It feels so soft and fluffy. Maybe it reminds me of the chicks at the farmyard. Creating little animals with fleecy yarn came very naturally to me. I just could not resist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My first project was a tiny, chubby mouse with the body and head knitted together. It was simple but I found the result completely adorable. Creating something cute using such a small quantity of yarn is utterly delightful. The knitting was very easy and quick, so I had to make more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is a collection of little pets that you can carry in your pocket. They can travel with you and entertain you whether you are travelling by a car, train or aeroplane. They are perfect for small hands.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You may find that fleecy yarn is not the easiest to knit with at the beginning. You cannot see stitches clearly and it is hard to recover a dropped stitch, but do not worry. Count your stitches from time to time and if you notice you have increased or decreased by accident, simply fix it on the next row. Making up is one of the challenges for beginners, but the seams are not visible with this yarn and the toys will have a lovely, neat finish. Intrigued?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Happy knitting!")])]), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4-2.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4-3.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4-4.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4-5.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg4-6.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg5-4.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ea652e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction.vue
// module id = 75
// module chunks = 0